import { selectCurrentUserInfo } from 'store/slices';
import { useAppSelector } from 'store/store.hook';
import { getImageRefreshed } from 'utils';
import { useFetchUsersQuery } from './users.api';

const getUserDetails = ({ user = {} } = {} as any) => {
  let newUser = { ...user };

  newUser = {
    ...newUser,
    profile_photo: getImageRefreshed(newUser?.profile_photo),
  };

  return newUser;
};

export const useUsers = () => {
  const { orgSlug } = useAppSelector(selectCurrentUserInfo);
  const { data: users = [], ...rest } = useFetchUsersQuery({ orgSlug });

  const data = users.map((user: any) => getUserDetails({ user }));

  return { data, ...rest };
};
